import { SaveRecordAction } from '@aibees/elephant/hooks';
import { useEnrichPersonSaveRecord } from '@aibees/elephant/hooks/people/use-enrich-person-save-record';
import { useSaveRecordEnrichableCount } from '@aibees/elephant/hooks/people/use-save-record-enrichable-count';
import { classnames } from '@aibees/shared/utils';
import { memo } from 'react';
import { InfoItem } from '../enrich-dialog';
import * as Styled from './styles';
import * as SX from './sx';
import type { ReVerifyEmailDialogProps as Props } from './types';

export const ReVerifyEmailDialog = memo(
  ({ className, open, onClose, table }: Props) => {
    const { enrichable, isLoading: countLoading } =
      useSaveRecordEnrichableCount(
        SaveRecordAction.CONTACT_REVERIFY_EMAIL,
        open ? table : undefined
      );

    const { handleEnrich, isLoading } = useEnrichPersonSaveRecord(
      SaveRecordAction.CONTACT_REVERIFY_EMAIL,
      onClose,
      table,
      enrichable
    );

    const informations: InfoItem[] = [
      {
        count: enrichable,
        label: 'records require email re-verification.',
      },
    ];

    return (
      <Styled.Wrapper
        className={classnames('ReVerifyEmailDialog', className)}
        sx={SX.root}
        open={open}
        onClose={onClose}
        icon="email-outline"
        title="Re-verify Emails"
        informations={informations}
        cost={0.1}
        onSubmit={handleEnrich}
        enrichLoading={isLoading}
        countLoading={countLoading}
        disableEnrich={!enrichable || enrichable === 0}
        unEnrichableHelperText="The selected contacts emails are already verified and don’t need re-verification."
        recordsCount={table?.selection.included.length || 0}
      />
    );
  }
);

ReVerifyEmailDialog.displayName = 'ReVerifyEmailDialog';
